import Backbone from 'backbone';
import Tools from '../../../services/Tools';
import BaseAPI from '../../../services/BaseAPI';
const ListView = require('../../../../components/view/ListView');
const ListViewItem = require('./item/ChatItemView');
const ListItemModel = require('../../../model/expand/list/item/ChatItemModel');
const $ = Backbone.$;
module.exports = Backbone.View.extend({
  tagName: 'div',
  initialize(o) {
    _.bindAll(
      this,
      'handleOnItemsUnread',
      'handleOnItemsRead',
      'dataConnect',
      'receiveMessage',
      'handleOnScrollTop',
      'handleScrollBottom',
      'createModelItem',
      'handleLoadingChange',
      'loadMoreMessage',
      'handleConnectChanged'
    );
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
    this.collection = new Backbone.Collection([]);

    this.listenTo(this.model, 'change:loading', this.handleLoadingChange);
  },

  handleScrollBottom() {
    if (!this.model.get('showChat')) {
      return;
    }
    const session_id = Tools.getSessionId(this.conf.domain_id);
    var userId = Tools.getUserId(this.conf.domain_id);
    var mid_late = Tools.getMidLate(this.conf.domain_id);
    let mid_mess_data = null;

    for (let index = this.conf.dataMess.data.length; index > 0; index--) {
      const element = this.conf.dataMess.data[index - 1];
      if (element.sender.sender_type == 'SUPPORTER') {
        mid_mess_data = element.mid;
        break;
      }
    }
    const mid_mess = this.conf.mid_late ? this.conf.mid_late : mid_mess_data;
    if (this.conf.flagMidLate && mid_late != mid_mess) {
      this.conf.flagMidLate = false;
      var confix = {
        url: `${this.conf.domainAPI}/visitor/update/last_read`,
        method: 'POST',
        body: {
          session_id: session_id,
          message_id: mid_mess
        }
      };
      var headers = {
        'Content-Type': 'application/json',
        cid: userId
      };
      BaseAPI.callAPI(
        confix,
        headers,
        response => {
          Tools.setMidLate(this.conf.domain_id, mid_mess);
          setTimeout(() => {
            this.conf.flagMidLate = true;
          }, 500);
        },
        error => {
          console.log('error', error);
          setTimeout(() => {
            this.conf.flagMidLate = true;
          }, 500);
        }
      );
    }
  },

  handleOnScrollTop() {
    this.loadMoreMessage();
  },

  loadMoreMessage() {
    const loading = this.model.get('loading');
    const readAll = this.model.get('readAll');
    if (loading || readAll) {
      return;
    }
    const { conf } = this;
    const session_id = Tools.getSessionId(this.conf.domain_id);
    const userId = conf.userId || Tools.getUserId(this.conf.domain_id);
    const that = this;
    const firstItem =
      this.collection && this.collection.length > 0 && this.collection.at(0);
    const token = firstItem && firstItem.get('mid');
    if (!userId) {
      this.model.set('readAll', true);
      return;
    }
    var confix = {
      url: `${
        this.conf.domainAPI
      }/chat/${session_id}/get_message?per_page=20&before_token=${this.conf
        .afterToken ||
        token ||
        ''}`,
      method: 'GET',
      body: ''
    };
    var headers = { cid: userId };
    this.model.set('loading', true);
    BaseAPI.callAPI(
      confix,
      headers,
      response => {
        this.model.set('loading', false);
        if (response.data.length > 0) {
          setTimeout(() => {
            that.listView.scrollTo(200);
          }, 500);
          // this.conf.dataMess.data = response.data.concat(this.conf.dataMess.data);
          this.conf.afterToken = response.data[0].mid;
          let models = [];
          for (let i = 0; i < response.data.length; i++) {
            const itemModels = this.createItemModels(response.data[i], true);
            models = models.concat(itemModels);
          }
          this.collection.add(models, { at: 0 });
          return;
        }
        this.model.set('readAll', true);
      },
      error => {
        this.model.set('loading', false);
        this.model.set('readAll', true);
        console.log('error', error);
      }
    );
  },

  receiveMessage(data, index, scroll = false) {
    const { conf, collection, listView, $el } = this;
    const that = this;
    const isBottom = listView.checkBottomScroll();
    if (data.message) {
      collection.add(this.createModelItem(data, null), { at: index });
    }

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(function(attachments, i) {
        collection.add(that.createModelItem(data, attachments), { at: index });
      });
    }
    if (data.sender.sender_type == 'VISITOR' || isBottom) {
      setTimeout(() => {
        listView.scrollToBottomNotAnimate();
        that.handleScrollBottom();
      }, 50);
      return;
    }
  },

  updateMessage(data) {
    const id = data.id;
    const updateModel = this.collection.findWhere({ id: id });
    if (!updateModel) {
      return;
    }
    updateModel.set('mid', data.mid);
    updateModel.set('status', 2); // status da gui
  },

  updateAttachments(attachments, id, mid) {
    if (!attachments || !attachments.length) {
      return;
    }
    const updateModels = this.collection.where({ idFile: id });
    if (!updateModels || !updateModels.length) {
      return;
    }
    updateModels.forEach((updateModel, index) => {
      if (attachments.length > index) {
        updateModel.set('attachments', attachments[index]);
        updateModel.set('mid', mid);
        updateModel.set('status', 2);
      }
    });
  },

  createModelItem(data, attachment, read = false) {
    const { conf } = this;
    const isVisitor = data.sender.sender_type == 'VISITOR' ? true : false;
    const model = {
      id: data.id,
      idFile: data.idFile,
      date: Tools.getDate(data.timestamp),
      message: data.message,
      avatar: data.sender.avatar,
      time: Tools.convertTime(data.timestamp),
      attachments: attachment,
      bg_color: isVisitor
        ? conf.background_color_vis
        : conf.background_color_sup,
      color_text: isVisitor ? conf.text_color_vis : conf.text_color_sup,
      domain: conf.domain,
      displayChat: conf.displayChat,
      type: isVisitor ? 1 : 2,
      sender_id: data.sender.id,
      mid: data.mid,
      showTime: false,
      read: read,
      status: data.status || 2 // 1: Chua gui, 2 : Da gui
    };
    return new ListItemModel(model, conf);
  },

  dataConnect(data) {
    const { conf, model } = this;
    const dataLoaded = model.get('dataLoaded');
    if (data && data.length) {
      this.clear();
      let models = [];
      for (let index = 0; index < data.length; index++) {
        const itemModels = this.createItemModels(data[index], true);
        models = models.concat(itemModels);
      }

      this.collection.set(models);
      setTimeout(() => {
        this.listView.scrollToBottomNotAnimate();
      }, 100);

      setTimeout(() => {
        this.listView.scrollToBottomNotAnimate();
        this.handleScrollBottom();
      }, 200);
    }
    if (conf.dataLoaded) {
      this.model.set('loading', false);
    }
  },

  setDataLoaded() {
    this.model.set('dataLoaded', true);
    this.model.set('loading', false);
  },

  scrollToBottom() {
    this.listView.scrollToBottomNotAnimate();
    // this.handleScrollBottom();
  },

  clear() {
    this.listView.clear();
  },

  createItemModels(data, read = false) {
    const models = [];
    const that = this;
    if (data.message) {
      models.push(that.createModelItem(data, null, read));
    }
    if (data.attachments.length > 0) {
      data.attachments.forEach(function(attachments, i) {
        models.push(that.createModelItem(data, attachments, read));
      });
    }
    return models;
  },

  renderUnreadButton() {
    const self = this;
    const { $el } = this;
    if (!this.unreadButton) {
      this.unreadButton = $(`<div class="unread-message-button mf">
                                  Tin nhắn mới 
                                  <div class="unread-message-red"></div>
                              </div>`);
      $el.append(this.unreadButton);
      this.unreadButton.on('click', function(e) {
        self.listView.scrollToBottom();
        // self.handleScrollBottom();
      });
    }
  },

  renderLoading() {
    const { $el, conf } = this;
    const { connected } = this.model;
    if (this.loadingEl) {
      this.loadingEl.remove();
      this.loadingEl = null;
    }
    this.loadingEl = $(
      `<div class="lw-loading mf">${
        !conf.connected ? 'Đang kết nối ...' : 'Đang tải ...'
      }</div>`
    );
    $el.append(this.loadingEl);
  },

  renderDisconnect() {
    const { $el, model, conf } = this;
    model.set('loading', false);
    if (this.disconnectEl) {
      this.disconnectEl.remove();
      this.disconnectEl = null;
    }
    this.disconnectEl = $(
      `<div class="lw-loading mf" style="background-color: red; color: #fff;">Mất kết nối ...</div>`
    );
    $el.append(this.disconnectEl);
  },

  handleOnItemsUnread(models) {
    const supportMsg = models.filter(model => {
      return model.get('type') !== 1;
    });
    if (supportMsg && supportMsg.length) {
      this.renderUnreadButton();
    } else {
      if (this.unreadButton) {
        this.unreadButton.remove();
        this.unreadButton = null;
      }
    }
  },

  handleOnItemsRead(models) {
    const supportMsg = models.filter(model => {
      return model.get('type') !== 1;
    });
  },

  handleLoadingChange(modal, val, options) {
    if (val) {
      this.renderLoading();
      return;
    }
    if (this.loadingEl) {
      this.loadingEl.remove();
      this.loadingEl = null;
    }
  },

  handleDisconnectChanged(disconnect) {
    if (!disconnect) {
      this.model.set('connected', true);
    } else {
      this.model.set('connected', false);
    }
  },

  handleConnectChanged(model, val, options) {
    if (val) {
      if (this.disconnectEl) {
        this.disconnectEl.remove();
        this.disconnectEl = null;
      }
      return;
    }
    this.renderDisconnect();
  },

  renderListView() {
    const { $el, el, conf } = this;
    this.listView = new ListView({
      collection: this.collection,
      itemView: ListViewItem,
      parent: el
    });

    this.listView.render();

    this.listenTo(this.listView, 'onItemsUnread', this.handleOnItemsUnread);
    this.listenTo(this.listView, 'onItemsRead', this.handleOnItemsRead);
    this.listenTo(this.listView, 'onScrollTop', this.handleOnScrollTop);
    this.listenTo(this.listView, 'scrollBottom', this.handleScrollBottom);
  },

  render() {
    const { $el, pfx, conf, collection } = this;
    $el.addClass(`${pfx}chat-list`);
    this.renderListView();

    this.listenTo(
      conf.canvas,
      'onDisconnectChanged',
      this.handleDisconnectChanged
    );
    this.listenTo(this.model, 'change:connected', this.handleConnectChanged);
    this.model.set('loading', true);
    return this;
  }
});
